/*jshint esversion: 9 */

/*
// jQuery: initAvailabilityFilterControls
// Availability Filter Controls is used to handle navigation of the Availability Results process
*/

jQuery(function initAvailabilityFilterControls($) {

	$('.availability-filter-controls').each(function(index, el) {

		var disableAvailability               = $('.disable-availability').val();

		if (disableAvailability !== 'yes') {

			var $siteBodyContainer            = $(document.body);
			var $container                    = $(this);
			var $mobileContainer              = $('.js-mobile-search');
			var $mobileMenuOverlay            = $('#js-btn-mobile-menu-close-overlay');
			var $availabilityResultsContainer = $('.availability-data-container');
			var $primaryControlsContainer     = $container.find('.js-primary-controls');
			var $secondaryControlsContainer   = $siteBodyContainer.find('.js-secondary-controls');
			var $secondaryFilterControls      = $container.find('.secondary-filter-controls');
			var $primaryFilterSets            = $container.find('.js-primary-filter-container');
			var $secondaryFilterSets          = $container.find('.js-filter-container');
			var $buttonControls               = $siteBodyContainer.find('.js-button-control');
			var $closeButtons                 = $container.find('.close-filters-btn');
			var $filterSections               = $container.find('.js-filter-section');

			var $desktopDateRangePicker       = $('.btn-travel-dates-primary');
			var $mobileDateRangePicker        = $('.btn-travel-dates-mobile');
			var $startDateControl             = $container.find('.js-date-start');
			var $endDateControl               = $container.find('.js-date-end');
			var $desktopDateRangePickerLabel  = $desktopDateRangePicker.find('.js-travel-dates-label');
			var $mobileDateRangePickerLabel   = $mobileDateRangePicker.find('.js-travel-dates-label');

			var resortID                      = $('.resort-id').val();
			var historyStateLog               = {};
			var isTransitioning               = false;
			var animationParameters           = {duration: 500, queue: false};
			var travelByDays                  = maxTravelByDays;
			var lastCompleteURL               = location.pathname;
			var localeLanguage                = 'en';

			var resetScrollPosition           = false;
			var lastScrollRow                 = '';
			var lastFieldName                 = '';
			var currentAvailabilityCount      = $('.initial-availability-count').val();
			var availabilityPerPage           = systemResultsPerPage;

			var appliedStartDate              = $startDateControl.val();
			var appliedEndDate                = $endDateControl.val();
			var previousStartDate             = '';
			var previousEndDate               = '';

			var disableTracking               = disableTrackingCode;
			var screenMode                    = ($( window ).width() <= 767) ? 'responsive' : 'standard';
		}

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             INITIALIZING FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:    initializeComponents
		// PARAMETERS:  none
		// DESCRIPTION: This function handles triggering of all appropriate major component initializers for the search process
		// **************************************************************************************************************
		var initializeComponents = function() {

			// The order of initialization for each function matters and must be done in the proper sequence

			if (disableAvailability !== 'yes') {

				initializeMobileSearch();
				initializeHistoryStateLog();
			}

			initializeControls();
		};

		// **************************************************************************************************************
		// FUNCTION:    initializeMobileSearch
		// PARAMETERS:  none
		// DESCRIPTION: This function handles moving the mobile search elements to the appropriate part of the dom. This is done at the time of initialization to allow
		//              the scrubbing functionality etag to only be run once for all initial filter segments, even though the HTML for the mobile search needs to live
		//              outside of and separately from the rest of the filter controls in the main template structure (to allow for the mobile responsive interface to work)
		// **************************************************************************************************************
		var initializeMobileSearch = function() {

			var $htmlSource      = $mobileContainer;
			var $htmlDestination = $('#js-mobile-menu-content');
			var $htmlContent     = $htmlSource.detach();
			$htmlDestination.append($htmlContent);
		};

		// **************************************************************************************************************
		// FUNCTION:    initializeHistoryStateLog
		// PARAMETERS:  none
		// DESCRIPTION: This function handles the inital popstate event that the browser triggers upon page load. First, it replaces the state in the browser history API
		//              so that we have a valid event history for this first page. Then, we build out the history log entry (which is used for caching our search data in
		//              the javascript layer to be used for history api reverts of the page content) with existing elements from the loaded page. The "initialFilters.filters"
		//              is a javascript variable that is manually loaded via an etag on page load, and contains the filters object of arrays that is needed for this history entry
		// **************************************************************************************************************
		var initializeHistoryStateLog = function() {

			history.replaceState({id: location.pathname}, '', location.pathname + location.search);
			historyObject = {'type': '', 'results': '', 'availabilityCount': '', 'filters': '', 'activeDescriptions': ''};

			historyObject.type                 = 'list';
			historyObject.results              = $availabilityResultsContainer.html().trim();
			historyObject.availabilityCount    = currentAvailabilityCount;
			historyObject.filters              = initialFilters.filters;
			historyObject.activeDescriptions   = initialFilters.activeDescriptions;
			historyStateLog[location.pathname] = historyObject;
		};

		// **************************************************************************************************************
		// FUNCTION:    initializeControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles setting up the event handlers for all of the Availability Process Interface Controls
		// **************************************************************************************************************
		var initializeControls = function() {

			if (disableAvailability !== 'yes') {

				loadDatePickers();
				loadSecondaryControls();
				loadMobileControls();
				loadCustomControls();
			}

			loadErrorControls();

			if (currentAvailabilityCount > 4) {

				toggleLoadAvailability('reset');
			}

			// Enable the stickyfill polyfill for all sticky positioned elements
			Stickyfill.add($('.sticky-polyfill-item'));
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             CONTROL CONFIGURATIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:    loadDatePickers
		// PARAMETERS:  none
		// DESCRIPTION: This function handles initializing the date range picker controls
		// **************************************************************************************************************
		var loadDatePickers = function() {

			moment.locale(localeLanguage);

			var dateRangePickerLocaleConfig = getLocaleConfiguration(localeLanguage);

			// Initialized and detach the desktop date-picker

			$desktopDateRangePicker.daterangepicker({
				opens: 'center',
				minDate: moment(),
				maxDate: moment().add(travelByDays, 'days'),
				locale: dateRangePickerLocaleConfig
			});

			$desktopDateRangePicker.on('apply.daterangepicker', function(ev, picker) {
				applyTravelDates('desktop', picker);
			});

			$desktopDateRangePicker.on('cancel.daterangepicker', function(ev, picker) {
				clearTravelDates(true);
			});

			$desktopDateRangePicker.on('show.daterangepicker', function(ev, picker) {
				//event.preventDefault(); // Removed for "GTM Event" conflict bug fix (Not sure if this was ever needed or not)
				$primaryFilterSets.each(function(el) {
					if ($(this).is(':visible')) { $(this).hide(); }
				});
				toggleButton($desktopDateRangePicker, 'on');

				$('body').removeClass('date-range-picker-active');
			});

			$desktopDateRangePicker.on('hide.daterangepicker', function(ev, picker) {
				$desktopDateRangePicker.removeClass('current');

				$('body').removeClass('date-range-picker-active');
			});

			if (appliedStartDate !== '' && appliedEndDate !== '') {

				$desktopDateRangePicker.data('daterangepicker').setStartDate(appliedStartDate);
				$desktopDateRangePicker.data('daterangepicker').setEndDate(appliedEndDate);
			}

			var $dateRangePickerDesktop = $('.daterangepicker').detach();

			// Initialized and detach the mobile date-picker

			$mobileDateRangePicker.daterangepicker({
				opens: 'center',
				minDate: moment(),
				maxDate: moment().add(travelByDays, 'days'),
				locale: dateRangePickerLocaleConfig
			});

			$mobileDateRangePicker.on('apply.daterangepicker', function(ev, picker) {
				applyTravelDates('mobile', picker);
			});

			$mobileDateRangePicker.on('cancel.daterangepicker', function(ev, picker) {
				clearTravelDates(true);
			});

			$mobileDateRangePicker.on('show.daterangepicker', function(ev, picker) {
				//event.preventDefault(); // Removed for "GTM Event" conflict bug fix (Not sure if this was ever needed or not)
				toggleButton($mobileDateRangePicker, 'on');

				$('body').addClass('date-range-picker-active');
			});

			$mobileDateRangePicker.on('hide.daterangepicker', function(ev, picker) {
				//event.preventDefault(); // Removed for "GTM Event" conflict bug fix (Not sure if this was ever needed or not)
				$mobileDateRangePicker.removeClass('current');

				$('body').removeClass('date-range-picker-active');
			});

			if (appliedStartDate !== '' && appliedEndDate !== '') {

				$mobileDateRangePicker.data('daterangepicker').setStartDate(appliedStartDate);
				$mobileDateRangePicker.data('daterangepicker').setEndDate(appliedEndDate);
			}

			var $dateRangePickerMobile = $('.daterangepicker').detach();

			// Re-attach the date-pickers to their required areas for proper display
			$('.primary-filter-group-container').append($dateRangePickerDesktop);
			$('.availability-filter-controls').append($dateRangePickerMobile);
		};

		// **************************************************************************************************************
		// FUNCTION:    loadSecondaryControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles setting up the "More Filters" / "Miscellaneous" related event handlers for all of the Availability Process Interface Controls
		// **************************************************************************************************************
		var loadSecondaryControls = function() {

			// **************************************************************************************************************
			// Primary Filter Button Controls [More Filters]
			// **************************************************************************************************************
			$('.btn-more-filters-primary').click(function(e) { toggleFilter(e, $('.btn-more-filters-primary'), $('.more-filters')); });

			// **************************************************************************************************************
			// More Filters Secondary Button Controls & Mobile Interface Filter Controls
			// **************************************************************************************************************
			$('.js-filter-section').each(function(el) {

				$(this).click(function(e) {

					// Close all other filter containers and reset their open class status
					$('.js-filter-container').not($(this).next('.js-filter-container')).hide();
					$('.js-filter-section').not($(this)).removeClass('open');

					// Toggle the selected filter container and open class status
					$(this).toggleClass('open');
					$(this).next('.js-filter-container').toggle();
				});
			});

			// **************************************************************************************************************
			// Secondary Filter Checkbox Controls
			// **************************************************************************************************************
			$container.find('.secondary-filter-container .js-checkbox .js-filter-checkbox').each(function(el) {

				$(this).click(function(e) {

					if (!isTransitioning) {

						isTransitioning = true;

						// Find the mobile filter version of the selected filter, so it can be manipulated appropriately as well
						var selectedMobileFilter = $mobileContainer.find('[name="' + $(this).attr('name') + '"]');

						if ($(this).hasClass('js-occupancy')) {

							// This is an occupancy or rating filter, we need to uncheck its siblings (it is treated like a radio button)

							$(this).closest('.js-checkbox').siblings().find('.js-filter-checkbox').prop('checked',false);
							selectedMobileFilter.closest('.js-checkbox').siblings().find('.js-filter-checkbox').prop('checked',false);
						}

						// Determine if we are unchecking a selection that may cause a zero result search due to other disabled selections in the same category
						checkDisabledSelections($(this), $(this).closest('.secondary-filter-option-container'));
						checkDisabledSelections(selectedMobileFilter, selectedMobileFilter.closest('.secondary-filter-option-container'));

						// Determine if we have any filter selections
						var filterSection = $(this).closest('.filter-set').data('filter-section');
						var filterItems   = checkFilterSelections($(this).closest('.filter-set'));

						if (filterItems) {

							$(filterSection).addClass('selected');
						}
						else {

							$(filterSection).removeClass('selected');
						}

						if (checkFilterSelections($secondaryFilterControls)) {

							toggleResetButton('secondary', 'on');
						}
						else {

							toggleResetButton('secondary', 'off');
						}

						performFacetedSearch($(this).attr('name'));
					}
					else {

						e.preventDefault();
					}
				});
			});

			// **************************************************************************************************************
			// Primary Filter Section Close Button Controls
			// **************************************************************************************************************
			$closeButtons.each(function(el) {

				$(this).click(function(e) {

					isTransitioning = true;
					toggleButton($($(this).data('button')), 'off');
					closeFilterSet($(this).closest('.js-primary-filter-container'));
				});
			});

			// **************************************************************************************************************
			// Reset Secondary Filters Control
			// **************************************************************************************************************
			$('.js-reset-more-filters').click(function() {

				if (!isTransitioning) {

					isTransitioning = true;
					clearSecondaryFilters();
				}
			});

			// **************************************************************************************************************
			// Load More Inventory Secondary Control
			// **************************************************************************************************************
			$('.load-availability-controls').click(function(e) {

				if (!isTransitioning) {

					isTransitioning = true;
					toggleLoadAvailability('load');
				}
			});

			// **************************************************************************************************************
			// Popstate event (Using the "Back" or "Forward" traversal buttons in the browser to move through the browser history)
			// **************************************************************************************************************
			$(window).on("popstate", function(e) {

				if (e.originalEvent.state !== null) {

					var key = e.originalEvent.state.id;

					if (key in historyStateLog) {

						// The state we are looking for exists in the history state log, so use that cached data instead of performing an AJAX search

						var dataJSON = historyStateLog[key];
						revertSearchInterface(dataJSON);
					}
					else {

						// The state we are looking for doesn't currently exist in the history state log, so we need to reload the page
						// This type of event should never occur, but we want to account for it just incase of some weird behavior

						window.location = location.pathname;
					}
				}
			});

			// **************************************************************************************************************
			// Check the window on the event of a resize, to determine if we need to switch our "screenMode" variable
			// **************************************************************************************************************
			$(window).on('resize', function() {

				if ($( window ).width() <= 767) {

					// Change screen mode type and close all standard interface filter sets, to smooth transitions betweeen interfaces
					$primaryFilterSets.hide();
					$buttonControls.removeClass('current');

					if (screenMode === 'standard') {

						if ($('.daterangepicker').is(':visible')) {

							$desktopDateRangePicker.data('daterangepicker').hide();
							$mobileDateRangePicker.data('daterangepicker').hide();
						}

						resetScrollPosition = false;
						toggleMobileMenu('n/a', 'off');
					}

					screenMode = 'responsive';
				}
				else {

					// Change screen mode type and close responsive interface filter set, to smooth transitions betweeen interfaces
					$siteBodyContainer.removeClass('mobile-menu-open');
					$mobileMenuOverlay.removeClass('js-search-overlay');

					if (screenMode === 'responsive') {

						if ($('.daterangepicker').is(':visible')) {

							$desktopDateRangePicker.data('daterangepicker').hide();
							$mobileDateRangePicker.data('daterangepicker').hide();
						}

						resetScrollPosition = false;
						toggleMobileMenu('n/a', 'off');
					}

					screenMode = 'standard';
				}
			});

			$(document).on('click', '.js-launch-mandatory-ai-modal', function(event) {

				event.preventDefault();

				var closeOnOverlay     = false;
				var $launchModalBtn    = $(this);
				var confirmRedirectURL = $launchModalBtn.attr('href');

				var message = $('#mandatory-ai-modal').html();
				message     = message.replace("CONFIRM_REDIRECT_URL", confirmRedirectURL);

				launchInfoDialogWithClass(message, closeOnOverlay, 'l-dialog-static');
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    loadMobileControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles setting up the "Mobile View" related event handlers for all of the Availability Process Interface Controls
		// **************************************************************************************************************
		var loadMobileControls = function() {

			// **************************************************************************************************************
			// Mobile - Menu Toggling Controls
			// **************************************************************************************************************
			$('.js-mobile-search-menu-close').click(function(e) {

				toggleMobileMenu('n/a', 'off');
			});

			$('#js-btn-mobile-menu-close-overlay').click(function(e) {

				if ($(this).hasClass('js-search-overlay')) {

					toggleMobileMenu('n/a', 'off');
				}
			});

			// **************************************************************************************************************
			// Mobile - More Filters Menu Control
			// **************************************************************************************************************
			$('.btn-more-filters-mobile').click(function(e) {

				toggleMobileMenu('more-filters', 'on');
			});

			// **************************************************************************************************************
			// Mobile - Checkbox Filter Controls
			// **************************************************************************************************************
			$mobileContainer.find('.js-filter-checkbox').each(function(el) {

				$(this).click(function(e) {

					if (!isTransitioning) {

						// Acquire the primary filter control version of this mobile search control, and activate it
						// This is done because the mobile filter controls are not replicated events of the primary interface, which performs all of the actual searching logic

						var selectedPrimaryFilter = $container.find('[name="' + $(this).attr('name') + '"]');
						selectedPrimaryFilter.trigger('click');
					}
					else {

						e.preventDefault();
					}
				});
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    loadCustomControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles instantiating any custom form controls for the availability process
		// **************************************************************************************************************
		var loadCustomControls = function() {

			// **************************************************************************************************************
			// Click Management Controls [Toggles modals / dropdowns closed when an outside container click is detected]
			// **************************************************************************************************************
			$('html').click(function(e) {

				if ($('.more-filters-container').is(':visible')) {

					if (!e.target.closest('.more-filters-modal')) {

						$('.btn-more-filters-primary').trigger('click');
					}
				}
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    loadErrorControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles instantiating any error form controls for the availability process
		// **************************************************************************************************************
		var loadErrorControls = function() {

			// **************************************************************************************************************
			// Error Message Controls
			// **************************************************************************************************************
			$('.error-message-container').click(function() {

				$('.js-error-message').slideUp($.extend({}, animationParameters));
			});
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             TRAVEL DATES FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:    getLocaleConfiguration
		// PARAMETERS:  localeLanguage (the locale language code for the requested configuration)
		// DESCRIPTION: This function handles acquiring local configurable parameters for the date range pickers
		// **************************************************************************************************************
		var getLocaleConfiguration = function(localeLanguage) {

			var configurationParams = {};

			switch (localeLanguage) {

				case 'en-gb':

					configurationParams = {
						"format": "DD/MM/YYYY",
						"separator": " - ",
						"applyLabel": "Apply",
						"cancelLabel": "Reset Calendar",
						"fromLabel": "From",
						"toLabel": "To",
						"weekLabel": "W",
						"daysOfWeek": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
						"monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
						"firstDay": 1
					};
					break;

				case 'es':

					configurationParams = {
						"format": "DD/MM/YYYY",
						"separator": " - ",
						"applyLabel": "Aplicar",
						"cancelLabel": "Restablecer calendario",
						"fromLabel": "Desde",
						"toLabel": "Hasta",
						"weekLabel": "S",
						"daysOfWeek": ["Do", "Lu", "Ma", "Mx", "Ju", "Vi", "Sa"],
						"monthNames": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
						"firstDay": 1
					};
					break;

				case 'pt-br':

					configurationParams = {
						"format": "DD/MM/YYYY",
						"separator": " - ",
						"applyLabel": "Aplique",
						"cancelLabel": "Repor o calendário",
						"fromLabel": "De",
						"toLabel": "Até",
						"weekLabel": "S",
						"daysOfWeek": ["Do", "Sg", "Te", "Qa", "Qi", "Sx", "Sa"],
						"monthNames": ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
						"firstDay": 1
					};
					break;

				default:

					configurationParams = {
						"format": "MM/DD/YYYY",
						"separator": " - ",
						"applyLabel": "Apply",
						"cancelLabel": "Reset Calendar",
						"fromLabel": "From",
						"toLabel": "To",
						"weekLabel": "W",
						"daysOfWeek": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
						"monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
						"firstDay": 1
					};
			}

			return configurationParams;
		};

		// **************************************************************************************************************
		// FUNCTION:    applyTravelDates
		// PARAMETERS:  pickerType ("desktop" / "mobile")
		//              picker (the picker instance control that is being triggered)
		// DESCRIPTION: This function handles the event of applying new travel dates and then performing a faceted search
		// **************************************************************************************************************
		var applyTravelDates = function(pickerType, picker) {

			isTransitioning    = true;
			var updatedDisplay = '';

			$startDateControl.val(picker.startDate.format('MM-DD-YYYY'));
			$endDateControl.val(picker.endDate.format('MM-DD-YYYY'));

			updatedDisplay = (picker.startDate.format('MMM-DD-YY') + ' | ' + picker.endDate.format('MMM-DD-YY')).replace(/\./g, '');

			$desktopDateRangePickerLabel.val(updatedDisplay);
			$mobileDateRangePickerLabel.val(updatedDisplay);

			if (pickerType === 'mobile') {

				$desktopDateRangePicker.data('daterangepicker').setStartDate(picker.startDate);
				$desktopDateRangePicker.data('daterangepicker').setEndDate(picker.endDate);
			}
			else {

				$mobileDateRangePicker.data('daterangepicker').setStartDate(picker.startDate);
				$mobileDateRangePicker.data('daterangepicker').setEndDate(picker.endDate);
			}

			checkDatesAndSearch(true);
		};

		// **************************************************************************************************************
		// FUNCTION:    clearTravelDates
		// PARAMETERS:  runSearch (boolean value that decides whether a faceted search should be performed as part of this function call)
		// DESCRIPTION: This function handles the event of clearing all travel dates and then performing a faceted search
		// **************************************************************************************************************
		var clearTravelDates = function(runSearch) {

			isTransitioning    = true;
			var updatedDisplay = '';

			$startDateControl.val('');
			$endDateControl.val('');

			$desktopDateRangePickerLabel.val(updatedDisplay);
			$mobileDateRangePickerLabel.val(updatedDisplay);

			$desktopDateRangePicker.data('daterangepicker').setStartDate(moment());
			$desktopDateRangePicker.data('daterangepicker').setEndDate(moment());
			$mobileDateRangePicker.data('daterangepicker').setStartDate(moment());
			$mobileDateRangePicker.data('daterangepicker').setEndDate(moment());

			checkDatesAndSearch(runSearch);
		};

		// **************************************************************************************************************
		// FUNCTION:    checkDatesAndSearch
		// PARAMETERS:  runSearch (boolean value that decides whether a faceted search should be performed as part of this function call)
		// DESCRIPTION: This function handles the determination if selected travel dates require a new search to be processed
		// **************************************************************************************************************
		var checkDatesAndSearch = function(runSearch) {

			var performSearch  = false;
			var displayMessage = false;
			var startDate      = $startDateControl.val();
			var endDate        = $endDateControl.val();

			if (startDate !== '' && endDate !== '') {

				// We have a valid set of dates

				if (startDate !== appliedStartDate || endDate !== appliedEndDate) {

					// The dates are different than the currently applied date range

					// Update the previous travel date variables
					previousStartDate = appliedStartDate;
					previousEndDate   = appliedEndDate;

					// Update the applied travel date variables
					appliedStartDate  = startDate;
					appliedEndDate    = endDate;
					performSearch     = true;
				}
			}
			else if (startDate === '' && endDate === '') {

				// We have a cleared set of dates

				if (startDate !== appliedStartDate && endDate !== appliedEndDate) {

					// The dates are different than the currently applied date range

					// Update the previous travel date variables
					previousStartDate = appliedStartDate;
					previousEndDate   = appliedEndDate;

					// Update the applied travel date variables
					appliedStartDate  = startDate;
					appliedEndDate    = endDate;
					performSearch     = true;
				}
			}
			else {

				// We have an incomplete set of dates

				if (appliedStartDate !== '' && appliedEndDate !== '') {

					// The user already had previously applied travel dates, so show them a message to indicate that they are still applied
					displayMessage = true;
				}
			}

			if (displayMessage) {

				// Display the fixed modal error message
				$('.js-error-message').html('NOTE: Your current Travel Dates are ' + appliedStartDate + ' through ' + appliedEndDate + '.');
				$('.js-error-message').slideDown($.extend({}, animationParameters));
			}
			else {

				// Reset any existing error messaging
				$('.js-error-message').hide();
				$('.js-error-message').empty();
			}

			if (performSearch && runSearch) {

				performFacetedSearch('travel-dates');
			}
			else {

				isTransitioning = false;
			}
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             MAJOR SEARCH FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:    performFacetedSearch
		// PARAMETERS:  fieldName (the input "name" of the field invoking the new search, to be used for reference in case of errors)
		// DESCRIPTION: This function handles building out the proper variables to be passed to the application to perform a faceted search
		// **************************************************************************************************************
		var performFacetedSearch = function(fieldName) {

			// We want the fieldName of the item selected passed in here incase of search error (zero results), so we can uncheck that item and gray it out
			// We can also provide a more descriptive error to the user in this scenario

			lastFieldName = fieldName;

			toggleLoading('on');

			// Reset any existing error messaging
			$('.js-error-message').hide();
			$('.js-error-message').empty();

			var moreResults         = false;
			var selections          = [];
			selections.sale         = $container.find('.js-sale:checked').toArray();
			selections.redemption   = $container.find('.js-redemption:checked').toArray();
			selections.pricetype    = $container.find('.js-pricetype:checked').toArray();
			selections.price        = $container.find('.js-price:checked').toArray();
			selections.bedroom      = $container.find('.js-bedroom:checked').toArray();
			selections.occupancy    = $container.find('.js-occupancy:checked').toArray();
			selections.kitchen      = $container.find('.js-kitchen:checked').toArray();

			var pathnameURL         = '';
			var completeURL         = '';
			var saleURL             = buildFilterSegmentURL(selections.sale, 'sale');
			var redemptionURL       = buildFilterSegmentURL(selections.redemption, 'redemption');
			var priceTypeURL        = buildFilterSegmentURL(selections.pricetype, 'price-types');
			var priceRangeURL       = buildFilterSegmentURL(selections.price, 'price-ranges');
			var bedroomTypeURL      = buildFilterSegmentURL(selections.bedroom, 'bedroom-types');
			var occupancyURL        = buildFilterSegmentURL(selections.occupancy, 'occupancy');
			var kitchenTypeURL      = buildFilterSegmentURL(selections.kitchen, 'kitchen-types');

			var travelDatesURL = '';

			if (appliedStartDate !== '' && appliedEndDate !== '') {

				travelDatesURL = '/travel-dates/' + appliedStartDate + '-through-' + appliedEndDate;
			}

			pathnameURL = travelDatesURL + saleURL + redemptionURL + priceTypeURL + priceRangeURL + bedroomTypeURL + occupancyURL + kitchenTypeURL;

			if (pathnameURL !== '') {

				pathnameURL = '/search-resorts/resort/' + resortID + '/availability' + pathnameURL;
			}
			else {

				pathnameURL = '/search-resorts/resort/' + resortID;
			}

			completeURL = pathnameURL;

			if (completeURL in historyStateLog) {

				// The state we are looking for exists in the history state log, so use that cached data instead of performing an AJAX search

				var dataJSON = historyStateLog[completeURL];
				updateSearchInterface(dataJSON);
				history.pushState({id: completeURL}, '', completeURL);
			}
			else {

				facetedSearchAJAX(pathnameURL, completeURL, fieldName);
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    facetedSearchAJAX
		// PARAMETERS:  pathnameURL (the pathname portion of the URL that the user is attempting to search on)
		//              completeURL (the full URL that the user is attempting to search on)
		//              fieldName (the input "name" of the field invoking the new search, to be used for reference in case of errors)
		// DESCRIPTION: This function handles performing the AJAX call to the server to retrieve a set of JSON response results for the search criteria
		// **************************************************************************************************************
		var facetedSearchAJAX = function (pathnameURL, completeURL, fieldName) {

			$.ajax({
				method: "POST",
				url: "/h/resort/PerformFacetedAvailabilitySearch",
				data: { searchURL: pathnameURL, resortid: resortID }
			})
				.done(function( data ) {

					var dataJSON = JSON.parse(data);

					if (dataJSON !== '') {

						if (dataJSON.type === 'no-results' || dataJSON.type === 'error') {

							revertForNoResults(fieldName, dataJSON.type);
						}
						else {

							updateSearchInterface(dataJSON).done(function() {

								// If this search has not been previously done this session, add it to the historyStateLog which will keep it as a running cache of the users front end searches
								// This is used for both popping between states with the forward and back button for instant results, as well as if the user re-searches something they have already
								// searched, thus saving processing time on the server side

								if (!(completeURL in historyStateLog)) {

									historyStateLog[completeURL] = dataJSON;
								}
							});

							history.pushState({id: completeURL}, '', completeURL);
							lastCompleteURL = completeURL;
						}
					}
				});
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                           INTERFACE UPDATE FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:    updateSearchInterface
		// PARAMETERS:  dataJSON (the full URL that the user is attempting to search on)
		// DESCRIPTION: This function handles updating the entire search interface after an AJAX search.
		//              Here we want smooth transitions and a nice user experience, as the user is creating new searches and processing time is required on the server side
		// **************************************************************************************************************
		var updateSearchInterface = function(dataJSON) {

			// This function makes use of a "Deffered" state so that callbacks performed during the "facetedSearchAJAX" and "performMapSearch" functions can store
			// data properly after all animations have completed (which effects opacity and visiblity of stored HTML blocks in the "historyStateLog")
			var deferred = $.Deferred();

			updateFilterControls(dataJSON.filters, false);
			updateAvailabilityCount(dataJSON.availabilityCount);
			updateActiveDescriptions(dataJSON.activeDescriptions);

			$availabilityResultsContainer.fadeOut($.extend({}, animationParameters, {
				complete: function() {

					$availabilityResultsContainer.html(dataJSON.results);
					$availabilityResultsContainer.fadeIn($.extend({}, animationParameters, {
						complete: function() {

							toggleLoading('off');
							deferred.resolve();
						}
					}));

					if (dataJSON.availabilityCount > 4) {

						toggleLoadAvailability('reset');
					}
				}
			}));

			// Set the "resetScrollPosition" back to false so that if we are in responsive mode, the interface will not attempt to scroll back to
			// a previous resulting list card, since a new result set has been loaded from performing a search or issuing a pop-state event
			resetScrollPosition = false;

			updateMoreFiltersDisplay();

			return deferred.promise();
		};

		// **************************************************************************************************************
		// FUNCTION:    revertSearchInterface
		// PARAMETERS:  dataJSON (the full URL that the user is attempting to search on)
		// DESCRIPTION: This function handles reverting the entire search interface after a popstate event, which needs to re-load previously cached front-end results.
		//              Here we want instantaneous re-loading of existing content that the user has already searched and we have cached on the front end
		// **************************************************************************************************************
		var revertSearchInterface = function(dataJSON) {

			if (dataJSON.type !== '') {

				var secondaryFilterCheck   = false;

				$buttonControls.removeClass('selected');
				$buttonControls.removeClass('current');
				$filterSections.removeClass('selected');
				$primaryFilterSets.hide();

				// Reset any existing error messaging
				$('.js-error-message').hide();
				$('.js-error-message').empty();

				// Update all filter control checkboxes
				updateFilterControls(dataJSON.filters, true);
				updateAvailabilityCount(dataJSON.availabilityCount);
				updateActiveDescriptions(dataJSON.activeDescriptions);

				// Determine if we have any active secondary filters, if so, show the Reset button, else hide it
				secondaryFilterCheck = checkFilterSelections($secondaryFilterControls);

				if (secondaryFilterCheck) {

					toggleResetButton('secondary', 'on');
				}
				else {

					toggleResetButton('secondary', 'off');
				}

				$availabilityResultsContainer.html(dataJSON.results);
				$availabilityResultsContainer.show();

				if (dataJSON.availabilityCount > 4) {

					toggleLoadAvailability('reset');
				}

				toggleLoading('off');

				// Set the "resetScrollPosition" back to false so that if we are in responsive mode, the interface will not attempt to scroll back to
				// a previous resulting list card, since a new result set has been loaded from performing a search or issuing a pop-state event
				resetScrollPosition = false;

				updateMoreFiltersDisplay();
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    revertForNoResults
		// PARAMETERS:  fieldName (the input "name" of the field invoking the new search, to be used for reference in case of errors)
		//              type (the type of error that was encountered during the faceted search process)
		// DESCRIPTION: This function handles reverting the interface back to its previous search state after a failed search that returned "No Results", in order to
		//              prevent the user from getting a blank set of results
		// **************************************************************************************************************
		var revertForNoResults = function(fieldName, type) {

			var fieldMessage = ' ';

			if (fieldName !== 'bypass') {

				if (fieldName === 'travel-dates') {

					fieldMessage = 'Travel Dates: ' + appliedStartDate + ' through ' + appliedEndDate;

					// Revert the applied travel date variables back to their previous values
					appliedStartDate  = previousStartDate;
					appliedEndDate    = previousEndDate;

					// Revert the travel date inputs back to their previous values
					$startDateControl.val(appliedStartDate);
					$endDateControl.val(appliedEndDate);

					var tempStartDate = appliedStartDate;
					var tempEndDate   = appliedEndDate;
					var activeRange   = true;

					if (appliedStartDate === '' && appliedEndDate === '') {

						tempStartDate = moment();
						tempEndDate   = moment();
						activeRange   = false;
					}

					// Revert the date range pickers back to their previous values
					$desktopDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
					$desktopDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);
					$mobileDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
					$mobileDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);

					var updatedDisplay = '';

					if (activeRange) {

						updatedDisplay = (moment(tempStartDate, 'MM-DD-YYYY').format('MMM-DD-YY') + ' | ' + moment(tempEndDate, 'MM-DD-YYYY').format('MMM-DD-YY')).replace(/\./g, '');
					}

					$desktopDateRangePickerLabel.val(updatedDisplay);
					$mobileDateRangePickerLabel.val(updatedDisplay);
				}
				else {

					var selectedFilter = $('[name="' + fieldName + '"]');

					if (selectedFilter.length) {

						// Update the field messaging
						fieldMessage = selectedFilter.next('.checkbox-label').html();

						// Determine if we need to un-check or check the appropriate filter checkbox
						if (selectedFilter.prop("checked")) {

							selectedFilter.prop("checked", false);
						}
						else {

							selectedFilter.prop("checked", true);
						}

						// Check to see if we need to disable or enable the "Selected" state of any buttons / controls for this filter
						var filterSection = selectedFilter.closest('.filter-set').data('filter-section');
						var filterItems   = checkFilterSelections(selectedFilter.closest('.filter-set'));

						if (filterItems) {

							$(filterSection).addClass('selected');
						}
						else {

							$(filterSection).removeClass('selected');
						}
					}
				}
			}

			// Determine if we have any active secondary filters, if so, show the Reset button, else hide it
			var secondaryFilterCheck = checkFilterSelections($secondaryFilterControls);

			if (secondaryFilterCheck) {

				toggleResetButton('secondary', 'on');
			}
			else {

				toggleResetButton('secondary', 'off');
			}

			if (type === 'error') {

				$('.js-error-message').html('An error has occured. Please try again.');
			}
			else {



				$('.js-error-message').html('Your most recent selection (' + fieldMessage + ') did not return any results. Please try another selection.');

				if (!disableTracking) {

					ga('send', 'event', 'Error', 'No Inventory - Resort Page');
				}
			}

			// Display the fixed modal error message
			$('.js-error-message').slideDown($.extend({}, animationParameters));

			toggleLoading('off');
		};

		// **************************************************************************************************************
		// FUNCTION:    updateFilterControls
		// PARAMETERS:  filters (the array of data containing all filter types and their possible checkbox selections, and their states [disabled and/or checked])
		//              isPopstate (boolean value that determines if this function is being called from a popstate, and requires us to update Filter Buttons as well as Filter Controls)
		// DESCRIPTION: This function handles updating all filter control checkboxes to their new proper state after a the "performFacetedSearch" function
		//              has pulled a new set of search results
		// **************************************************************************************************************
		var updateFilterControls = function(filters, isPopstate) {

			if (filters !== '') {

				// We have an updated set of filter controls, update them accordingly

				resetFilterControls($primaryControlsContainer);

				// Then disable any checkboxes that are no longer available
				$.each(filters, function(filterKeyType, filterSet) {

					if (filterKeyType === 'traveldates') {

						// Travel Dates filters (This only needs to be updated when we are reverting from a popstate event)

						if (isPopstate) {

							// Revert the applied travel date variables back to the historically stored values
							appliedStartDate  = filterSet.startdate;
							appliedEndDate    = filterSet.enddate;

							// Revert the travel date inputs back to the historically stored values
							$startDateControl.val(appliedStartDate);
							$endDateControl.val(appliedEndDate);

							var tempStartDate = appliedStartDate;
							var tempEndDate   = appliedEndDate;
							var activeRange   = true;

							if (appliedStartDate === '' && appliedEndDate === '') {

								tempStartDate = moment();
								tempEndDate   = moment();
								activeRange   = false;
							}

							// Revert the date range pickers back to the historically stored values
							$desktopDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
							$desktopDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);
							$mobileDateRangePicker.data('daterangepicker').setStartDate(tempStartDate);
							$mobileDateRangePicker.data('daterangepicker').setEndDate(tempEndDate);

							var updatedDisplay = '';

							if (activeRange) {

								updatedDisplay = (moment(tempStartDate, 'MM-DD-YYYY').format('MMM-DD-YY') + ' | ' + moment(tempEndDate, 'MM-DD-YYYY').format('MMM-DD-YY')).replace(/\./g, '');
							}

							$desktopDateRangePickerLabel.val(updatedDisplay);
							$mobileDateRangePickerLabel.val(updatedDisplay);
						}
					}
					else {

						$.each(filterSet, function(key) {

							if (this.isDisabled === 1 || this.isChecked === 1) {

								var selectedFilter = $('[name="' + filterKeyType + '-' + this.urlKey + '"]');

								if (this.isDisabled === 1) {

									selectedFilter.prop('disabled', true);
									selectedFilter.next('span').addClass('checkbox-label-disabled');
								}

								if (this.isChecked === 1) {

									selectedFilter.prop('checked', true);

									if (isPopstate) {

										$(selectedFilter.closest('.filter-set').data('button')).addClass('selected');
									}
								}
							}
						});
					}
				});
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    updateDestinationControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles updating the display label for all of the "More Filters" buttons
		// **************************************************************************************************************
		var updateMoreFiltersDisplay = function() {

			var numFilters = countFilterSelections($secondaryFilterControls);

			if (numFilters >= 1) {

				$('.js-more-filters-label').html('Filters - ' + numFilters);
			}
			else {

				$('.js-more-filters-label').html('More Filters');
			}
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                          RESETTING / CLEARING CONTORLS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:   toggleResetButton
		// PARAMETERS: sectionType (the section of the interface where we are toggling the applicable reset button)
		//             switchType (the switch to determine if we are displaying the Reset button, or hiding it)
		// DESCRIPTION: This function handles the display and hiding of the destinations and secondary filters reset buttons
		// **************************************************************************************************************
		var toggleResetButton = function(sectionType, switchType) {

			var filterSelections   = '';
			var filterCountClass   = '';
			var filterContentClass = '';
			var buttonClass        = '';

			filterSelections   = $secondaryFilterControls;
			filterCountClass   = '.js-reset-more-filters-count';
			filterContentClass = '.js-reset-more-filters-content';
			containerClass     = '.js-reset-more-filters-container';

			if (switchType === 'on') {

				var selectedFilters = countFilterSelections(filterSelections);

				$(filterCountClass).html(selectedFilters);

				if (selectedFilters === 1) {

					$(filterContentClass).html('filter');
				}
				else {

					$(filterContentClass).html('filters');
				}

				$(containerClass).show();
			}
			else {

				$(filterCountClass).html('0');
				$(containerClass).hide();
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    resetFilterControls
		// PARAMETERS:  resetSource (the source parent element that all child checkboxes need to be reset to "enabled" instead of "disabled")
		//              resetCheckedStatus (if this status is set to "true", that means we want to "uncheck" all child checkboxes of our "resetSource" as well)
		// DESCRIPTION: This function handles resetting all child checkbox elements of the "resetSource" element to "enabled" and  "unchecked"
		// **************************************************************************************************************
		var resetFilterControls = function(resetSource) {

			resetSource.find('.js-filter-checkbox').each(function() {

				$(this).prop('disabled', false);
				$(this).next('span').removeClass('checkbox-label-disabled');
				$(this).prop('checked', false);
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    clearSecondaryFilters
		// PARAMETERS:  none
		// DESCRIPTION: This function handles the clearing of all secondary filter checkboxes,
		//              and re-running the new faceted search without those options
		// **************************************************************************************************************
		var clearSecondaryFilters = function() {

			// Reset all secondary filter checkboxes

			$('.secondary-filter-option-container').each(function() {

				resetFilterControls($(this));
			});

			// Reset the secondary filter control button states

			$filterSections.each(function() {

				$(this).removeClass('selected');
			});

			toggleResetButton('secondary', 'off');
			performFacetedSearch('bypass');
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                                TOGGLE FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:   toggleMobileMenu
		// PARAMETERS: sectionType (the section of the interface we are toggling in the mobile menu)
		//             switchType (the switch to determine if we are displaying the menu, or hiding it)
		// DESCRIPTION: This function handles the display and hiding of the destinations and more filters mobile menus
		// **************************************************************************************************************
		var toggleMobileMenu = function(sectionType, switchType) {

			if (!isTransitioning) {

				if (switchType === 'off') {

					// The new scroll position must be calculated before removing the container classes from the mobile menu
					// Otherwise, the css transition animations cause the scroll offset to be computed incorrectly
					var newScrollPosition = ((screenMode === 'responsive') && resetScrollPosition) ? lastScrollRow.offset().top - 124 : 0;

					// Hide both mobile menu views, thus ensuring proper management of which view to display when toggling the mobile menu from different locations
					$('.js-mobile-search').hide();
					$('#js-mobile-menu-content').find('.navigation').hide();

					$siteBodyContainer.removeClass('mobile-menu-open');
					$mobileMenuOverlay.removeClass('js-search-overlay');

					// The new scroll position must be applied after the mobile menu container classes have been removed
					if ((screenMode === 'responsive') && resetScrollPosition) {

						$('html, body').scrollTop(newScrollPosition);
					}
				}
				else {

					resetScrollPosition = false;

					if (screenMode === 'responsive') {

						var currentScroll   = $(document).scrollTop();
						var headerContainer = $('.header-container');

						// When enabling the mobile menu and the header container is in the viewport, then we do not want to
						// perform a scroll reset to an availability row position when closing the menu because the user is near the top of the page

						if ((headerContainer.offset().top + headerContainer.outerHeight(true)) < currentScroll) {

							// When enabling the mobile menu and availability results are displayed, determine the top most viewable availability row
							// so the user may potentially be returned to that viewing point if no new search selections are made

							var currentAvailabilityRows = $('.availability-item');

							if (currentAvailabilityRows.length > 0) {

								currentAvailabilityRows.each(function() {

									if ($(this).offset().top >= currentScroll) {

										resetScrollPosition = true;
										lastScrollRow       = $(this);
										return false;
									}
								});
							}
						}
					}

					// Hide / show the appropriate mobile menu views for this mobile menu toggle operation
					$('.js-mobile-search').show();
					$('#js-mobile-menu-content').find('.navigation').hide();

					$('.js-mobile-container-destinations').hide();
					$('.js-mobile-container-more-filters').show();
					$siteBodyContainer.addClass('mobile-menu-open');
					$mobileMenuOverlay.addClass('js-search-overlay');
				}
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleLoading
		// PARAMETERS:  count (the total number of resorts available in the current set of search results)
		// DESCRIPTION: This function handles toggling on and off for the "Loading" animations, and for enabling / disabling all controls during the "Loading" process
		// **************************************************************************************************************
		var toggleLoading = function(mode) {

			if (mode === 'on') {

				// Disable all Primary and Mobile Controls and Modal Windows
				$('.filters').addClass('loading');
				$('.mobile-menu-content-container').addClass('loading');
				$mobileContainer.addClass('loading');
			}
			else {

				// Enable all Primary and Mobile Controls and Modal Windows
				$('.filters').removeClass('loading');
				$('.mobile-menu-content-container').removeClass('loading');
				$mobileContainer.removeClass('loading');

				// Complete the transition by resetting the transition check parameters
				isTransitioning = false;
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleFilter
		// PARAMETERS:  button (the button element being toggled)
		//              filter (the filter set associated with the toggled button)
		// DESCRIPTION: This function handles the toggling open and closed of a filter set when its control button is pressed
		// **************************************************************************************************************
		var toggleFilter = function(e, button, filter) {

			if (!isTransitioning) {

				// Ensure we stop click propagation from moving up further and hitting the click management
				// event that exists on the <html> DOM element of the page. Instead, manage all click related
				// events locally in this specific click event handler
				e.stopPropagation();

				isTransitioning = true;

				if (filter.is(':visible')) {

					toggleButton(button, 'off');
					closeFilterSet(filter);
				}
				else {

					toggleButton(button, 'on');
					closeAllFilterSets(filter);
				}
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleButton
		// PARAMETERS:  button (the button element being toggled)
		//              toggleSwitch (the state of the button we are changing to, "on" or "off")
		// DESCRIPTION: This function handles the toggling on and off of a control button when it is pressed
		// **************************************************************************************************************
		var toggleButton = function(button, toggleSwitch) {

			$buttonControls.each(function() {

				$(this).removeClass('current');
			});

			if (toggleSwitch !== 'off') {

				button.addClass('current');
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    openFilterSet
		// PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be opened)
		// DESCRIPTION: This function handles opening of the appropriate supplied filter
		// **************************************************************************************************************
		var openFilterSet = function(filter) {

			filter.show();
			isTransitioning = false;
		};

		// **************************************************************************************************************
		// FUNCTION:    closeFilterSet
		// PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be closed)
		// DESCRIPTION: This function handles closing of the appropriate supplied filter
		// **************************************************************************************************************
		var closeFilterSet = function(filter) {

			filter.hide();
			isTransitioning = false;
		};

		// **************************************************************************************************************
		// FUNCTION:    closeAllFilterSets
		// PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be opened)
		// DESCRIPTION: This function handles closing all potentially open filter sets, then opening the new appropriate filter
		// **************************************************************************************************************
		var closeAllFilterSets = function(filter) {

			$primaryFilterSets.each(function(el) {

				if ($(this).is(':visible')) { $(this).hide(); }
			});

			openFilterSet(filter);
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleLoadAvailability
		// PARAMETERS:  type (the toggle type associated with the availability loader scenario)
		// DESCRIPTION: This function handles displaying and resetting hidden availability items
		// **************************************************************************************************************
		var toggleLoadAvailability = function(type) {

			if (type === 'load') {

				var count      = 1;
				var moreToLoad = false;

				$('.hide-availability-item').each(function() {

					if (count <= availabilityPerPage) {

						$(this).removeClass('hide-availability-item');
					}
					else {

						moreToLoad = true;
						return false;
					}

					count++;
				});

				if (!moreToLoad) {

					$('.load-availability-controls').hide();
				}

				isTransitioning = false;
			}
			else if (type === 'reset') {

				$('.load-availability-controls').show();
			}
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                          COUNTER / CHECKER FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:    checkDisabledSelections
		// PARAMETERS:  filterSource (the checkbox element that is being clicked on [being "Checked" or "Unchecked"])
		//              resetSource (the source parent element that all child checkboxes need to be reset to "enabled" instead of "disabled")
		// DESCRIPTION: This function handles validating whether or not a checkbox has been de-selected, and is the last non-disabled checkbox selection being unchecked
		//              This is being validated because if it is the last applicable checkbox in its filter set (Checked and Enabled), and we have other checkboxes in
		//              the filter set that are non-applicable (Checked and Disabled, due to other overlapping facets causing that function to not be contributing to the results),
		//              then we need to make sure to reset all filters in that filter set back to their default state to prevent a zero results search from occurring
		// **************************************************************************************************************
		var checkDisabledSelections = function(filterSource, resetSource) {

			if (!filterSource.prop("checked")) {

				// We are unchecking a box, determine if this is the last non-disabled checked selection that is being unchecked
				var numberChecked         = resetSource.find('.js-filter-checkbox:checked').length;
				var numberCheckedDisabled = resetSource.find('.js-filter-checkbox:checked:disabled').length;

				if (numberChecked === numberCheckedDisabled && numberChecked > 0 && numberCheckedDisabled > 0) {

					// We are unchecking the last applicable box (Checked and Enabled), and we have other non-applicable boxes
					// We need to reset this filter to remove all checked options, otherwise we will get a zero result search

					resetFilterControls(resetSource);
				}
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    checkFilterSelections
		// PARAMETERS:  filterSource (the parent filter set of options that contains the child checkbox elements that need to be validated)
		// DESCRIPTION: This function handles validating whether or not a checkbox in the "filterSource" is "checked". One checkbox being "checked" is sufficent for the whole set
		// **************************************************************************************************************
		var checkFilterSelections = function(filterSource) {

			var returnCheck = false;

			filterSource.find('.js-filter-checkbox').each(function() {

				if ($(this).prop('checked')) {

					// Set the 'returnCheck' to true to indicate we have at least one selection within the filterSource subset
					// Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 selection is sufficient)

					returnCheck = true;
					return false;
				}
			});

			return returnCheck;
		};

		// **************************************************************************************************************
		// FUNCTION:    countFilterSelections
		// PARAMETERS:  filterSource (the parent filter set of options that contains the child checkbox elements that need to be validated)
		// DESCRIPTION: This function handles counting the number of elements in the "filterSource" that are "checked"
		// **************************************************************************************************************
		var countFilterSelections = function(filterSource) {

			var count = 0;

			filterSource.find('.js-filter-checkbox').each(function() {

				if ($(this).prop('checked')) {

					count++;
				}
			});

			return count;
		};

// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************
//
//                                             MISCELLANEOUS FUNCTIONS
//
// **************************************************************************************************************
// **************************************************************************************************************
// **************************************************************************************************************

		// **************************************************************************************************************
		// FUNCTION:    buildFilterSegmentURL
		// PARAMETERS:  selectionSet (the set of checkbox options, in array format, that are "checked" for this specific segmentType)
		//              segmentType (the type, or category, of checkbox options that are being processed)
		// DESCRIPTION: This function builds out a url structure segment identical to what our search process router on the application looks for to determine
		//              whether or not a url is valid and contains properly formatted url keys for the segmentType selections in question
		// **************************************************************************************************************
		var buildFilterSegmentURL = function(selectionSet, segmentType) {

			var url = '';

			if (selectionSet.length > 0) {

				url = '/' + segmentType + '/XXXX';

				selectionSet.sort(function(a,b) {

					var A = a.value.toLowerCase();
					var B = b.value.toLowerCase();

					if (A < B) {

						return -1;
					}
					else if (A > B) {

						return 1;
					}
					else {

						return 0;
					}
				});

				$.each(selectionSet, function(key, inputElement) {

					url = url + '-and-' + $(inputElement).val();
				});

				url = url.replace('XXXX-and-','');
			}

			return url;
		};

		// **************************************************************************************************************
		// FUNCTION:    updateAvailabilityCount
		// PARAMETERS:  count (the total number of units available in the current set of availability results)
		// DESCRIPTION: This function handles updating the total number of units available
		// **************************************************************************************************************
		var updateAvailabilityCount = function(count) {

			currentAvailabilityCount = parseInt(count, 10);
			$('.js-unit-count').html(count);

			if (currentAvailabilityCount === 1) {

				$('.js-content-units').html('Unit');
			}
			else {

				$('.js-content-units').html('Units');
			}

			// Determine which label to display for the responsive resort counter section
			if (currentAvailabilityCount > 0) {

				$('.js-header-label').hide();
				$('.js-unit-counter').show();
			}
			else {

				$('.js-header-label').show();
				$('.js-unit-counter').hide();
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    updateActiveDescriptions
		// PARAMETERS:  activeDescriptions (an array of descriptions for active Sales and Redemptions)
		// DESCRIPTION: This function handles the display of any active Sale or Redemption descriptions
		// **************************************************************************************************************
		var updateActiveDescriptions = function(activeDescriptions) {

			var outputHTML = '';

			if (activeDescriptions.length) {

				outputHTML = '<div class="active-special-price-descriptions">';

				$.each(activeDescriptions, function(key, value) {

					outputHTML = outputHTML + '<div class="active-description">' + value + '</div>';
				});

				outputHTML = outputHTML + '</div>';
			}

			$('.js-active-descriptions').empty();
			$('.js-active-descriptions').html(outputHTML);
		};

		initializeComponents();
	});
});